import AbsComponent from '../../common/components/AbsComponent';
import ListinfoTempl from './ListinfoTempl';

/**
 * Sub1 class
 * @category testApp
 */
class Listinfo extends AbsComponent{
    constructor(_store={}, _el=''){
        super(_store, _el);
        if(_store.data.config.isMyCharacter === true){
            this.store.getCharacterListData(_store.data.config.serverType, this.render.bind(this));
        }
        /*else{ // 타인 캐릭터는 호출하지 않음
            this.store.getOtherCharactersListData(_store.data.basicInfoData.accountId, this.render.bind(this));
        }*/
    }

    render(_jsonData = {}){
        $(this.el).append(ListinfoTempl.getTempl(_jsonData, this.store.data.config));
    }
}

export default Listinfo;